import Navigation from './navigation';
import SearchHeader from './search-header';

let viewportWidth;
let lastScrollValue = 0;

const $BODY     = document.body;
const MAX_WIDTH = 770;

const init = (instance) => {
    instance.$burger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        instance.showNavigation();
    });

    instance.$searchBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        instance.showSearch();
    });

    window.addEventListener('scroll', () => {
        setHeaderType(instance.$el);
    });

    window.addEventListener('resize', () => {
        viewportWidth = $BODY.offsetWidth;
        setHeaderType(instance.$el);
    })
};

const setHeaderType = ($header) => {
    let scroll       = window.scrollY || window.pageYOffset;
    let headerHeight = $header.offsetHeight + $header.getBoundingClientRect().top;

    if (viewportWidth > MAX_WIDTH) {
        $header.classList.remove('header--fixed');
        $header.classList.remove('header--visible');
        $header.classList.remove('header--hidden');
        $BODY.style.paddingTop = `0px`;

        return false;
    }

    if ($header.getBoundingClientRect().top <= 0) {
        $header.classList.add('header--fixed');
        $BODY.style.paddingTop = `${headerHeight}px`;

        if (scroll < lastScrollValue) {
            $header.classList.remove('header--hidden');
            $header.classList.add('header--visible');
        }
        if (scroll > lastScrollValue) {
            if ($header.classList.contains('header--visible')) {
                $header.classList.remove('header--visible');
                $header.classList.add('header--hidden');
            }
        }
    }

    if ($header.parentNode.getBoundingClientRect().top >= 0) {
        $header.classList.remove('header--fixed');
        $header.classList.remove('header--visible');
        $header.classList.remove('header--hidden');
        $BODY.style.paddingTop = `0px`;
    }

    lastScrollValue = scroll <= 0 ? 0 : scroll;
};

export default class Header {
    constructor() {
        this.$el        = document.querySelector('.header');
        this.$burger    = this.$el.querySelector('.header__button--burger');
        this.$searchBtn = this.$el.querySelector('.search-form__control');

        this.navigation = new Navigation();
        this.search     = new SearchHeader();

        init(this);
    }

    showNavigation() {
        this.search.hide();
        this.navigation.show();
    }

    showSearch() {
        this.navigation.hide();
        this.search.show();
    }

    hideAll() {
        this.navigation.hide();
        this.search.hide();
    }
}
